import { render, staticRenderFns } from "./CustomerCreditStatus.vue?vue&type=template&id=f01cf786&scoped=true&"
import script from "./CustomerCreditStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditStatus.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditStatus.vue?vue&type=style&index=0&id=f01cf786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01cf786",
  null
  
)

export default component.exports